var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section text-left" }, [
    _c("h3", { staticClass: "sr-only" }, [_vm._v("Subscription Details")]),
    _vm._v(" "),
    _c("dl", { staticClass: "padding-left-0" }, [
      _c("dt", { staticClass: "display-inline-block" }, [
        _vm._v("Subscription ID:"),
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "display-inline-block margin-bottom-0" }, [
        _vm._v(_vm._s(_vm.id)),
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "sr-only" }, [
        _vm._v("Email associated with subscription"),
      ]),
      _vm._v(" "),
      _c("dd", { staticStyle: { "overflow-wrap": "break-word" } }, [
        _vm._v(_vm._s(_vm.email)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }